///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import IReportDistributor = Meevo.Plugins.Reports.IReportDistributor;

    export class InventoryDistributorsCollection extends SmartMoverApiCollection<IReportDistributor> implements IApiCollection<IReportDistributor> {

        protected get url() {
            return 'report/Distributor';
        }

        get value(): ModelValueType[] {
            return this.selectedModels
                .filter(row => row.id !== '-1')
                .map(row => row.id);
        }

        constructor(connectedModel: ModelValueType[], items: IReportDistributor[] = [], options: ICollectionOptions<IReportDistributor> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                'businessTypeList': null,
                'locationList': null,
                'hierarchyId': null,
                'branchId': null,
                'objectStateEnumList': [ObjectStateEnum.Active],
                'displayName': null,
                'fieldOrderBy': 'DisplayName',
                'orderAscDesc': 'Ascending',
                'IncludeInactive': true,
                'IncludeActive': true
            });
        }
    }

}
